/* eslint-disable react/prop-types */
import {
  // eslint-disable-next-line no-unused-vars
  Typography, makeStyles, Button,
} from '@material-ui/core'
import React from 'react'
import FieldText from '@components/CustomFields/FieldText'
import FieldTextPassword from '@components/CustomFields/FieldTextPassword'
import FieldAutocomplete2 from '@components/CustomFields/FieldAutocomplete2'
import { getCitiesOrDistricts } from '@api/collection'
import icons from '@assets/icons'

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    width: '90%',
    flexDirection: 'column',
    marginTop: 20,
    height: '100%',
    paddingBottom: 200,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
    },
  },
  txReceiver: {
    fontWeight: 'bold',
    fontSize: 20,
  },
  passwordContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonLogin1: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: '80%',
    alignSelf: 'center',
    backgroundColor: '#FFFFFF',
  },
  spaces: {
    marginTop: 100,
    display: 'flex',
  },
  txRegister: {
    alignSelf: 'center',
  },
  buttonUseExisting: {
    width: 250,
    alignSelf: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}))

const FormRegister = ({
  reset,
  setIsUseExistingAcc,
  register,
  isSubmitting,
  isUseExistingAcc,
  setFormValue,
  setOpen,
  watch,
  availableAccountData,
  ...props
}) => {
  const classes = useStyles()

  const withAvailableAccount = watch('provider') === 'available_account'

  const onClickNewEmail = () => {
    setIsUseExistingAcc(false)
    reset()
  }

  return (
    <div className={classes.form}>
      <input type="text" name="provider" ref={register} hidden />
      <Typography
        variant="h6"
        className={classes.txReceiver}
      >
        Data Reseller
      </Typography>
      <FieldText
        name="name"
        label="Nama Lengkap"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <FieldText
        name="phone"
        label="Nomor Hp/Whatsapp"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <FieldText
        name="email"
        label="Email"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      { !withAvailableAccount && (
      <div className={classes.passwordContainer}>
        <FieldTextPassword
          name="password"
          label="Kata Sandi"
          register={register}
          isSubmitting={isSubmitting}
          {...props}
        />
        <FieldTextPassword
          name="password_confirmation"
          label="Konfirmasi Kata Sandi"
          register={register}
          isSubmitting={isSubmitting}
          {...props}
        />
      </div>
      )}
      <FieldText
        name="address"
        label="Alamat"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <FieldAutocomplete2
        name="district"
        label="Kota / Kecamatan"
        register={register}
        api={getCitiesOrDistricts}
        placeholder="Cari Kota / Kabupaten..."
        getOptionValue={(option, value) => option.id === value.id}
        getOptionLabel={(value) => value?.formated_name}
        defaultValues={{ district: availableAccountData?.data?.district }}
        searchParams="name"
        {...props}
      />
      <Typography
        color="textSecondary"
        className={classes.txRegister}
      >
        Atau gunakan akun terdaftar
      </Typography>
      {
      !isUseExistingAcc
        ? (
          <Button
            variant="contained"
            color="inherit"
            className={classes.buttonLogin1}
            onClick={() => setOpen(true)}
            startIcon={(
              <img
                src={icons.MaleIcon}
                height={32}
                width={32}
                alt="male"
              />
          )}
          >
            Login dengan akun dari store lain
          </Button>
        )
        : (
          <Button
            variant="contained"
            color="primary"
            onClick={onClickNewEmail}
            className={classes.buttonUseExisting}
            startIcon={(
              <img
                src={icons.AddUserIcon}
                height={32}
                width={32}
                alt="male"
              />
            )}
          >
            Gunakan Email Baru
          </Button>
        )
      }
    </div>
  )
}

export default FormRegister
